module.exports = __webpack_public_path__ + "img/77.bdd334b1.jpg";